import React from "react";

const Report: React.FC = () => {
  return (
    <div>
      <h1>Anchor quality and density reports</h1>
      <p>Coming soon...</p>
    </div>
  );
};

export default Report;
